import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { Expandable2 } from '../../../../components/Expandable/Expandable2';
import Item from '../../../../components/Lists/Item';
import './TimeControl.css';
import { HTTP_RESPONSE_CODES, LABELS } from '../../../../globals/globals';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import Input from '../../../../components/Inputs/Input';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import { SpecificOverrides } from './SpecificOverrides';
import { getTimeControlInfo, saveTimeControl } from '../../services/TimeControlsService';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import BasicDatePicker from '../../../../components/Datepicker/Datepicker';
import { ThreshInterval } from './ThreshInterval';
import { useDispatch, useSelector } from 'react-redux';
import { deleteControl, discardControlChanges, fetchSpecificControl, formChange, saveControl, selectEditingControl, selectIdxForms, selectOverrides, toggleCtrlEdition } from '../../../../redux/features/configuration/parts/TimeControlsSlice';
import { Skeleton } from '@mui/material';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { DialogTrigger } from '../../../../components/Dialog/Dialog';
import DeletePartDialog from './DeletePartDialog';


export const TimeControl2 = ({ part, timeControl }) => {

    // const [editing, setEditing] = useState(false);
    const editing = useSelector((state) => selectEditingControl(state, timeControl.id));
    const { successMsg, warningMsg, infoMsg } = useSnackBar();
    const dispatch = useDispatch();
    const form = useSelector((state) => selectIdxForms(state, timeControl?.id)); 

    const saveClick = (closeEdition) => {
        infoMsg("Saving time control");
        dispatch(saveControl({ controlId: timeControl.id, part, closeEdition })).then(action => {
            let { response } = action.payload;
            if (response.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
                successMsg("Time Control Saved");
            } else {
                warningMsg(response.message, response.validationErrors?.map(e => e.error).join(", "));
            }
        }
        );
    }

    const removeControl = () => {
        dispatch(deleteControl({ controlId: timeControl.id })).then(action => {
            if (action.payload) {
                successMsg("Control successfully removed");
            }
        }
        )

    }

    const startEdition = () => {
        //TODO: dispatch edition starting;
        dispatch(toggleCtrlEdition({ controlId: timeControl.id, toValue: true }));
    }

    const cancelEdition = () => {
        // TODO: dispatch cancel edition : discard local changes or discard control;
        // TODO: call delete service;
        if (form.version === 0) {
            dispatch(deleteControl({ controlId: timeControl.id }))
            infoMsg("Time Control discarded");
        }
        dispatch(discardControlChanges({ controlId: timeControl.id }));
        // dispatch(toggleCtrlEdition({ controlId: timeControl.id, toValue: false }));
    }

    const discardControl = () => {
        dispatch(deleteControl({ controlId: timeControl.id }))
        infoMsg("Time Control discarded");
    }

    const saveButtons = useRef(null);

    const [openStatus, setOpenStatus] = useState(false);

    return (
        <div className='time-control-component'>
            <Expandable2 onOpenChange={(e) => setOpenStatus(e)} summary={
                <Item
                    ribbon={[{ when: editing, label: LABELS.EDITION_MODE }]}
                    item={{ "Engineering Task": timeControl?.etId || "--", "Name": timeControl?.etName || "--" }}
                >
                    <div className='item-actions'>
                        {!editing &&
                            (openStatus ? <button className='transparent'>
                                <i className='icon-edit actionbutton' onClick={(e) => { startEdition() }}></i>
                            </button> : <i className='icon-edit actionbutton' onClick={(e) => { startEdition() }}></i>)
                        }
                        {editing && <MultioptionButton buttons={[
                            { label: 'Save and Finish', onClick: () => { saveClick(true) }, icon: "icon-save", id: 'save' },
                            { label: 'Save and Continue Editing', onClick: () => { saveClick(false) }, icon: "icon-save", id: 'save-continue' },
                            { label: 'Cancel', onClick: () => { cancelEdition() }, icon: "icon-cross", id: 'cancel', type: 'danger' }
                        ]}></MultioptionButton>}

                        {form?.version === 0 ? <i onClick={() => discardControl()} className='icon-delete-new actionbutton'></i> : <DialogTrigger dialogContent={{
                            component: DeletePartDialog, props: {
                                item: { "Engineering Task": `${timeControl?.etId ?? ''}-${timeControl?.etName ?? ""}` },
                                message: "Are you sure you want to delete this time Control?",
                                onDelete: removeControl
                            }
                        }}>
                            <i className='icon-delete-new actionbutton'></i>
                        </DialogTrigger>}
                    </div>
                </Item>
            } name="pn-time-control" >
                <TimeControlContent
                    editing={editing}
                    part={part}
                    timeControl={timeControl}
                />

            </Expandable2>

        </div>);

}

// const companyParameter = [{ "columnName": "companyId", value: localStorage.getItem('u_company_id') }];

const threshFormNames = {
    threshHours: "thresholdHours",
    threshCycles: "thresholdCycles",
    threshDays: "thresholdDays",
    totalHours: "thresholdTotalHours",
    totalCycles: "thresholdTotalCycles",
    totalDays: "thresholdTotalDays",
    threshSchedule: "thresholdScheduleDate",
    threshLatest: "thresholdLatest",
    intervalHours: "intervalHours",
    intervalCycles: "intervalCycles",
    intervalDays: "intervalDays",
    intervalSchedule: "intervalScheduleDate",
    intervalLatest: "intervalLatest",
}

const TimeControlContent = ({ open, editing, part, timeControl }) => {
    // const controlsDropdown = useDropdownConfig(60);
    const engTaskDropdown = useDropdownConfig(50);
    const overrides = useSelector((state) => selectOverrides(state, timeControl.id))
    // const [overrides, setOverrides] = useState([1]);
    const form = useSelector((state) => selectIdxForms(state, timeControl?.id));
    const [formDisabled, setFormDisabled] = useState(false);
    const [threshForm, setThreshForm] = useState({
        threshHours: "",
        threshCycles: "",
        threshDays: "",
        totalHours: "",
        totalCycles: "",
        totalDays: "",
        threshSchedule: "",
        threshLatest: false,
        intervalHours: "",
        intervalCycles: "",
        intervalDays: "",
        intervalSchedule: "",
        intervalLatest: false,
    })
    const [preSelectEngTask, setPreSelectEngTask] = useState(timeControl?.etId ?? null);
    const dispatch = useDispatch();


    useEffect(() => {
        if (open) {
            dispatch(fetchSpecificControl({ control: timeControl }));
        }
    }, [open]);

    useEffect(() => {
        if (form) {
            setThreshForm({
                threshHours: form.thresholdHours || "",
                threshCycles: form.thresholdCycles || "",
                threshDays: form.thresholdDays || "",
                totalHours: form.thresholdTotalHours || "",
                totalCycles: form.thresholdTotalCycles || "",
                totalDays: form.thresholdTotalDays || "",
                threshSchedule: form.thresholdScheduleDate,
                threshLatest: form.thresholdLatest,
                intervalHours: form.intervalHours || "",
                intervalCycles: form.intervalCycles || "",
                intervalDays: form.intervalDays || "",
                intervalSchedule: form.intervalScheduleDate,
                intervalLatest: form.intervalLatest,
            })
            if (form.engineeringTask) {
                setFormDisabled(false);
            } else {
                setFormDisabled(true);
            }
        }
    }, [form]);

    const updateThreshForm = (e) => {
        const { name, value } = e;
        setThreshForm(prev => ({
            ...prev,
            [name]: value
        }));
        dispatch(formChange({ name: threshFormNames[name], value, controlId: timeControl.id }));
    }

    const controlInfoChange = (e) => {
        let { name } = e;
        dispatch(formChange({ ...e, controlId: timeControl.id }));
    }


    const [companyParameter, _] = useState([{ "columnName": "companyId", value: localStorage.getItem('u_company_id') }]);


    return (
        <div className='control-content'>
            {/* <div style={{ display: "none" }}> */}
            {/* <Dropdowns data={controlsDropdown.config} /> */}
            {/* </div> */}
            {true &&
                <>
                    {form ?
                        <div className='edit-mode'>
                            <div className='header'>

                                {/* <Input label="Engineering Task" /> */}
                                {/* //TODO: handle dropdown sleectionChange */}
                                <Dropdowns required disabled={!editing} onOptionSelect={(newOption) => controlInfoChange({ name: 'engineeringTask', value: newOption })} preSelectValue={form.engineeringTask?.id} parameters={companyParameter} data={engTaskDropdown.config} />
                                <CheckboxField disabled={!editing || formDisabled} onChange={(e) => controlInfoChange({ name: 'overrideValue', value: e })} checked={form.overrideValue}>Override</CheckboxField>
                                <CheckboxField disabled={!editing || formDisabled} onChange={(e) => controlInfoChange({ name: 'useFlightDays', value: e })} checked={form.useFlightDays}>Use Flight Days</CheckboxField>
                                <b>Repeat Number</b>
                                <Input hideErrorLabel required disabled={!editing || formDisabled} onChange={(e) => controlInfoChange({ name: 'maxRepetitions', value: e.target.value })} isNumeric value={form.maxRepetitions} />
                            </div>
                            {/* TODO: ThreshInterval props & change handlers */}
                            {threshForm && <ThreshInterval
                                values={threshForm}
                                onChange={updateThreshForm}
                                disabled={!editing || formDisabled}
                            />}
                        </div>
                        :
                        <div>
                            <Skeleton height="var(--input-height)" width="100%" />
                            <Skeleton height="var(--input-height)" width="100%" />
                        </div>
                    }
                </>
            }
            <SpecificOverrides overrides={overrides} timeControl={timeControl} part={part} />

        </div>
    )
}